import { addColor, canChangeColor, clearColors } from './colorHandling.js';
import { clearAllPattern, patternHandling } from './patternHandling.js';
import {
  getColors,
  getDecals,
  getProductId,
  getStyles,
  getTexts,
  getTextures,
  LoadDecals,
  loadFonts,
  restoreStyles,
  restoreTextures,
} from './sharing.js';
import { clearAllStyle, redoStyle, styleHandling, undoStyle } from './styleHandling.js';
import { pushTextUndoQueue } from './text/textUndoRedoUtils.js';
import { clearTexts, insertTextOnModel } from './textHandling.js';
import {
  createArrayWithLengthCallback,
  handleToolbarChanged,
  ObservableValue,
  updateClearState,
  updateRedoState,
  updateUndoState,
} from './toolButtonState.js';
import { doTheDelete, pushUndoQueue } from './undoRedoLogo.js';

const $ = window.jQuery;
const THREE = window.THREE;
var container;
var containerBox;
export var defaultSize = 1;
export var object;
export var renderer, scene, camera;
export var mesh = [];
var currentMeshUrl = '';
var currentNormalUrl = '';
export var undoColors = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateUndoState(array);
  updateClearState();
});
export var redoColors = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateRedoState(array);
  updateClearState();
});

export var undoPatterns = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateUndoState(array);
  updateClearState();
});
export var redoPattern = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateRedoState(array);
  updateClearState();
});

export var undoLogo = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateUndoState(array);
  updateClearState();
});
export var redoLogo = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateRedoState(array);
  updateClearState();
});

export var undoText = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateUndoState(array);
  updateClearState();
});
export var redoText = createArrayWithLengthCallback([], (newLength, oldLength, array) => {
  updateRedoState(array);
  updateClearState();
});

let textureURL;
export let currentProduct = null;

let raycaster;
let controls;
let light;
let materialShininess = 25;
let lightPower = 0.45;
export const intersection = {
  intersects: false,
  point: new THREE.Vector3(),
  normal: new THREE.Vector3(),
};
let mouse = new THREE.Vector2();
let textureLoader = new THREE.TextureLoader();

let texture;

export var toolbarActive = new ObservableValue('logo');
toolbarActive.addListener((value) => handleToolbarChanged(value));

window.decals = [];
export var mouseHelper;
export var size = new THREE.Vector3(10, 10, 10);

let moved = false;
let dragged = false;
export const updateTheLogo = [];
export const logoSelectionChanged = [];

window.addEventListener('load', () => {
  setTimeout(() => {
    init();
  }, 1000);
});
let timer;
function debounce(fc) {
  clearTimeout(timer);
  timer = setTimeout(() => {
    fc();
  }, 100);
}

let timerUpdate;
function debounceUpdate(fc) {
  clearTimeout(timerUpdate);
  timerUpdate = setTimeout(() => {
    fc();
  }, 1000);
}

export function updateProduct() {
  debounceUpdate(async () => {
    const product = getProductId();
    const arrColors = getColors();
    const patternTemp = getTextures();
    const arrPattern = [];

    undoPatterns.forEach((element) => {
      const pat = patternTemp?.find((i) => i?.id === element?.id);
      const index = arrPattern?.findIndex((i) => i?.id === element?.id);
      if (element?.id === pat?.id && index < 0) {
        arrPattern.push(pat);
      }
    });

    const arrLogos = getDecals();
    var design_hub_object = {};
    const arrTexts = getTexts();
    design_hub_object.logos = arrLogos.filter((i) => i?.Thumbnail);
    design_hub_object.texts = arrTexts.filter((i) => i?.Text);
    design_hub_object.textures = arrPattern;
    design_hub_object.colors = arrColors;
    design_hub_object.styles = getStyles ? getStyles() : [];
    console.log('design_hub_object', design_hub_object);

    const body = {
      item: {
        id: product?.Id,
        cart_item_id: +product?.cart_item_id,
        cart_id: +product?.cart_id,
        customer_id: +product?.customer_id,
        product_id: product?.product_id,
        product_name: product?.Name,
        origin_obj_main: product?.Mesh,
        texture_normal: product?.TextureNormal,
        texture: product?.Texture,
        design_hub_object: JSON.stringify(design_hub_object),
      },
    };
    if (product?.order_item_id) {
      delete body.item.cart_item_id;
      body.item.order_item_id = +product?.order_item_id;
    }
    try {
      console.log('PUT--New Data');
      await fetch(`${product?.url}/V1/designhub/${product?.order_item_id ? 'order' : 'cart'}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${product?.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
    } catch (error) {
      console.log('error', error);
    }
  });
}

export function clearAll(type) {
  window.currentLogo = null;
  switch (type) {
    case 'logo':
      window.showControl(false, 0, 0);
      clearAllLogo();
      if (undoLogo) undoLogo.splice(0);
      if (redoLogo) redoLogo.splice(0);
      break;
    case 'text':
      window.showControlText(false);
      if (undoText) undoText.splice(0);
      if (redoText) redoText.splice(0);
      clearTexts();
      // Clear text UI state and deselect
      if (typeof window.deselectText === 'function') {
        try {
          window.deselectText();
        } catch (e) {}
      }
      if (typeof window.clearTextUIState === 'function') {
        try {
          window.clearTextUIState();
        } catch (e) {}
      }
      break;
    case 'style':
      clearAllStyle();
      if (undoStyle) undoStyle.splice(0);
      if (redoStyle) redoStyle.splice(0);
      break;
    case 'color':
      clearColors(mesh);
      if (undoColors) undoColors.splice(0);
      if (redoColors) redoColors.splice(0);
      break;
    case 'pattern':
      clearAllPattern();
      if (undoPatterns) undoPatterns.splice(0);
      if (redoPattern) redoPattern.splice(0);
      break;
    default:
      console.log('ERROR');
      break;
  }
}
export function handleScene(value) {
  scene.add(value);
  //updateProduct();
}

export function addObject(scene, obj) {
  handleScene(obj);
  if (toolbarActive.value === 'logo') {
    for (let i = undoLogo.length - 1; i >= 0; i--) {
      if (undoLogo[i]?.value?.logo?.Id === obj?.logo?.Id) {
        scene.remove(undoLogo?.[i]?.value);
        break;
      }
    }

    updateDecals();
  }

  if (toolbarActive.value === 'text') {
    for (let i = undoText.length - 1; i >= 0; i--) {
      if (undoText[i]?.value?.logo?.Id === obj?.logo?.Id) {
        scene.remove(undoText?.[i]?.value);
        break;
      }
    }

    updateDecals();
  }

  debounce(() => {
    if (toolbarActive.value === 'logo') {
      pushUndoQueue(updateDecals, redoLogo, window.decals, undoLogo);
    }
    if (toolbarActive.value === 'text') {
      pushTextUndoQueue();
    }
  }, 10);
}

export function handleAddText(value) {
  if (value && value.logo) {
    pushTextUndoQueue();
  }
}

export function addText(value) {
  if (toolbarActive.value === 'text') {
    handleScene(value);
  }

  debounce(() => {
    handleAddText(value);
  }, 10);
}

export function updateLogoSelectionChanged(logo) {
  for (let i = 0; i < logoSelectionChanged.length; i++) {
    if (logoSelectionChanged[i](logo) === true) {
      return;
    }
  }
}

export function setIntervalX(callback, delay, repetitions) {
  var x = 0;
  var intervalID = window.setInterval(function () {
    callback();

    if (++x === repetitions) {
      window.clearInterval(intervalID);
    }
  }, delay);
}

export function unHightLight() {
  if (
    intersection.mesh != null &&
    intersection.mesh.material &&
    intersection.mesh.material.emissive
  ) {
    if (intersection.mesh.material.emissive.r == 0) {
      intersection.mesh.material.emissive.setRGB(0.25, 0.25, 0.25);
    } else {
      intersection.mesh.material.emissive.setRGB(0, 0, 0);
    }
  }
}

export function blinkDecals() {
  if (
    window.currentLogo != null &&
    window.currentLogo.decalMesh &&
    window.currentLogo.decalMesh.material
  ) {
    if (window.currentLogo.decalMesh.material.emissive) {
      if (window.currentLogo.decalMesh.material.emissive.r == 0) {
        window.currentLogo.decalMesh.material.emissive.setRGB(0.25, 0.25, 0.25);
      } else {
        window.currentLogo.decalMesh.material.emissive.setRGB(0, 0, 0);
      }
    }
  }
}

var decalHighLight = null;
export function resetDecalHighLight() {
  if (decalHighLight != null && decalHighLight.material && decalHighLight.material.emissive) {
    decalHighLight.material.emissive.setRGB(0.0, 0.0, 0.0);
    decalHighLight = null;
  }
}

export function highLightDecals(event) {
  getMousePos(event);
  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(window.decals);

  if (intersects.length > 0) {
    resetDecalHighLight();
    decalHighLight = intersects[intersects.length - 1].object.logo.decalMesh;
    if (decalHighLight && decalHighLight.material && decalHighLight.material.emissive) {
      decalHighLight.material.emissive.setRGB(0.25, 0.25, 0.25);
    }
  } else {
    resetDecalHighLight();
  }
}

export function checkIntersection() {
  if (!object) return;
  raycaster.setFromCamera(mouse, camera);

  var intersects = raycaster.intersectObjects([object], true);

  if (intersects.length > 0) {
    var p = intersects[0].point;
    mouseHelper.position.copy(p);
    intersection.point.copy(p);
    var n = intersects[0].face.normal.clone();
    n.transformDirection(intersects[0].object.matrixWorld);
    n.multiplyScalar(10);
    n.add(intersects[0].point);

    intersection.normal.copy(intersects[0].face.normal);
    mouseHelper.lookAt(n);

    //FOR TESTING: NORMAL LINE
    /*const positions = line.geometry.attributes.position;
    positions.setXYZ(0, p.x, p.y, p.z);
    positions.setXYZ(1, n.x, n.y, n.z);
    positions.needsUpdate = true;*/

    if (canChangeColor) {
      if (
        intersection.mesh != null &&
        intersection.mesh.material &&
        intersection.mesh.material.emissive
      ) {
        intersection.mesh.material.emissive.setRGB(0, 0, 0);
      }
      intersection.mesh = intersects[0].object;
      if (intersection.mesh.material && intersection.mesh.material.emissive) {
        intersection.mesh.material.emissive.setRGB(0.25, 0.25, 0.25);
      }
      setIntervalX(unHightLight, 100, 5);

      addColor();
    } else {
      intersection.mesh = intersects[0].object;
      intersection.intersects = true;
    }
  } else {
    intersection.intersects = false;
  }
}

export function getCanvasRelativePosition(event) {
  const rect = renderer.domElement.getBoundingClientRect();
  return {
    x: ((event.clientX - rect.left) * renderer.domElement.width) / rect.width,
    y: ((event.clientY - rect.top) * renderer.domElement.height) / rect.height,
  };
}

export function getMousePos(event) {
  const pos = getCanvasRelativePosition(event);
  mouse.x = (pos.x / renderer.domElement.width) * 2 - 1;
  mouse.y = -(pos.y / renderer.domElement.height) * 2 + 1;
  //checkIntersection();
}

export function clearPickPosition() {
  // unlike the mouse which always has a position
  // if the user stops touching the screen we want
  // to stop picking. For now we just pick a value
  // unlikely to pick something
  mouse.x = -100000;
  mouse.y = -100000;
}

export function updateCurrent() {
  console.log('toolbarActive.value', toolbarActive.value);
  console.log('window.currentLogo', window.currentLogo);
  console.log('window.currentPattern', window.currentPattern);

  // Check toolbarActive first to determine which feature to apply
  // Color is already applied in checkIntersection() when canChangeColor is true
  if (toolbarActive.value === 'color') {
    // Color mode: color is already applied in checkIntersection(), just return
    return;
  } else if (
    toolbarActive.value === 'pattern' &&
    window.currentPattern &&
    intersection.mesh != null
  ) {
    // Apply pattern when in pattern mode
    patternHandling.updatePattern(window.currentPattern, intersection);
  } else if (
    window.currentLogo &&
    window.currentLogo.IsText === true &&
    intersection.mesh !== null
  ) {
    console.log(window.currentLogo);
    window.showControlText(true);
    insertTextOnModel(window.currentLogo, intersection);
  } else if (toolbarActive.value === 'logo' && window.currentLogo && !window.currentLogo.IsText) {
    // Only insert logo if we have a logo selected and it's not text
    if (typeof window.deselectText === 'function') {
      window.showControlText(false);
      try {
        window.deselectText();
      } catch (error) {}
    }
    insertLogoOnModel();
  } else {
    // No logo selected or in other modes, just deselect text if needed
    if (typeof window.deselectText === 'function') {
      window.showControlText(false);
      try {
        window.deselectText();
      } catch (error) {}
    }
  }
}

export function updateControl(isShow) {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('decal')) {
    return;
  }
  const deleteElement = document.getElementById('delete');

  // Check toolbarActive first to determine which mode we're in
  // Only check values relevant to the current mode
  if (toolbarActive.value === 'logo') {
    // Logo mode: only check logo-related values
    if (window.currentLogo == null) {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    } else if (window.currentLogo && window.currentLogo.IsText === true) {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    } else if (isShow) {
      deleteElement?.style.setProperty('display', 'block');
      window.showControl(true, window.currentLogo.Scale, window.currentLogo.Rotate);
    } else {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    }
  } else if (toolbarActive.value === 'pattern') {
    // Pattern mode: only check pattern-related values
    if (window.currentPattern) {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    } else {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    }
  } else if (toolbarActive.value === 'text') {
    // Text mode: only check text-related values
    if (window.currentLogo && window.currentLogo.IsText === true) {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    } else {
      deleteElement?.style.setProperty('display', 'none');
      window.showControl(false, 0, 0);
    }
  } else {
    // Other modes (color, style, etc.): hide controls
    deleteElement?.style.setProperty('display', 'none');
    window.showControl(false, 0, 0);
  }
}

export function mouseMove(event) {
  moved = true;
  if (dragged) {
    resetDecalHighLight();
    getMousePos(event);
    checkIntersection();
    updateCurrent();
  } else {
    highLightDecals(event);
  }
}

export function mouseDown(event, texts) {
  moved = false;
  dragged = false;
  updateControl(false);
  window.showControlText(false);

  if (
    !window.isSelectedLogoTool ||
    window.isShareYourDesign ||
    (window.isSelectingStyle !== undefined && !window.isSelectingStyle)
  ) {
    return;
  }
  getMousePos(event);
  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(window.decals);
  console.log('mouseDown', intersects);
  if (toolbarActive.value === 'logo') {
    if (
      intersects.length > 0 &&
      (intersects[0].object.logo.hasOwnProperty('IsText') === false ||
        !intersects[0].object.logo.IsText)
    ) {
      window.currentLogo = intersects[0].object.logo;
      updateControl(true);
      updateLogoSelectionChanged(window.currentLogo);
      // Auto-active logo in list when selected on model
      if (
        window.setActiveLogoIndexById &&
        typeof window.setActiveLogoIndexById === 'function' &&
        window.currentLogo.Id
      ) {
        window.setActiveLogoIndexById(window.currentLogo.Id);
      }
      dragged = true;
      controls.enableRotate = false;
    }
  } else if (toolbarActive.value === 'text') {
    const isPlacingNewText =
      window.currentLogo && window.currentLogo.IsText === true && !window.currentLogo.Position;

    if (
      !isPlacingNewText &&
      intersects.length > 0 &&
      intersects[0].object.logo.hasOwnProperty('IsText')
    ) {
      window.showControlText(true);
      window.currentLogo = intersects[0].object.logo;
      dragged = true;
      controls.enableRotate = false;
      if (typeof window.selectTextDecals === 'function') {
        window.selectTextDecals(intersects[0].object.logo);
      }
    } else if (isPlacingNewText) {
      // Always place the new text, even if clicking on top of another text
      drop(event);
    } else {
      // Clicked outside text and not placing a new one -> just deselect current text
      if (window.currentLogo?.Position) {
        if (typeof window.deselectText === 'function') {
          try {
            window.deselectText();
          } catch (error) {}
        }
        window.currentLogo = null;
      }
    }
  }
}

export function mouseUp(event) {
  getMousePos(event);
  dragged = false;
  controls.enableRotate = true;

  if (window.isShareYourDesign) return;
  checkIntersection();
  if (intersection.intersects && window.isSelectedLogoTool) {
    updateCurrent();
  }
}

export function onContainerResize() {
  const size = container?.getBoundingClientRect();
  const width = size?.width;
  const height = size?.height;

  // Update renderer size
  renderer.setSize(width, height);

  // Update camera aspect ratio
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
}

export function restoreFullView() {
  if (container == null || container.parentElement == null) return;
  container.style.width = '100%';
  container.style.backgroundImage = '';
  containerBox = container?.getBoundingClientRect();
  renderer.setSize(containerBox?.width, containerBox?.height);
  camera.aspect = containerBox?.width / containerBox?.height;
  camera.updateProjectionMatrix();
}

export function resizeFullView() {
  if (container == null || container.parentElement == null) {
    //recall after 1 second
    setTimeout(resizeFullView, 1000);
    return;
  }

  containerBox = container?.getBoundingClientRect();
  renderer.setSize(containerBox?.width, containerBox?.height);
  camera.aspect = containerBox?.width / containerBox?.height;
  camera.updateProjectionMatrix();
}

export function mouseWheel(evt) {
  if (evt.altKey && window.currentLogo != null) {
    controls.enableZoom = false;
    evt.preventDefault();
    window.currentLogo.Scale += evt.wheelDelta / 100;
    updateLogoChange(window.currentLogo);
  } else {
    controls.enableZoom = true;
  }
}

export function init() {
  container = document.getElementById('container');
  const deleteButton = document.getElementById('delete');

  deleteButton?.addEventListener('click', () => {
    window.showControl(false, 0, 0);
    doTheDelete();
  });

  renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  //renderer.setSize(window.innerWidth, window.innerHeight);
  containerBox = container?.getBoundingClientRect();

  renderer.setSize(containerBox?.width, containerBox?.height);

  renderer.setClearColor(0xffffff, 0);
  container?.appendChild(renderer.domElement);
  container?.addEventListener('resize', onContainerResize);

  scene = new THREE.Scene();

  camera = new THREE.PerspectiveCamera(50, containerBox?.width / containerBox?.height, 1, 1000);
  camera.position.z = 120;
  camera.target = new THREE.Vector3();

  controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.rotateSpeed = 0.05;
  controls.enableKeys = false;
  controls.enablePan = false;
  controls.minDistance = 10;
  controls.maxDistance = 300;

  controls.addEventListener('change', light_update);

  scene.add(new THREE.AmbientLight(0xffffff, lightPower));

  light = new THREE.PointLight(0xffffff, lightPower);
  light.position.set(0, 200, 0);
  scene.add(light);

  var geometry = new THREE.BufferGeometry();
  geometry?.setFromPoints([new THREE.Vector3(), new THREE.Vector3()]);

  raycaster = new THREE.Raycaster();

  mouseHelper = new THREE.Mesh(
    new THREE.BoxBufferGeometry(1, 1, 10),
    new THREE.MeshNormalMaterial(),
  );
  mouseHelper.visible = false;
  scene.add(mouseHelper);

  window.addEventListener('resize', onContainerResize, false);
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Delete' && window.currentLogo !== null) {
      if (window.currentLogo?.Position !== undefined && window.currentLogo?.Position != null) {
        $('#deleteDialog').modal({ show: true });
      }
      return;
    }
  });

  renderer.domElement.addEventListener('wheel', mouseWheel);

  renderer.domElement.addEventListener('mousemove', mouseMove, false);
  renderer.domElement.addEventListener(
    'touchmove',
    (event) => {
      mouseMove(event.touches[0]);
    },
    false,
  );

  renderer.domElement.addEventListener('mousedown', mouseDown, false);
  renderer.domElement.addEventListener(
    'touchstart',
    (event) => {
      // prevent the window from scrolling
      event.preventDefault();
      mouseDown(event.touches[0]);
    },
    false,
  );

  renderer.domElement.addEventListener('mouseup', mouseUp, false);
  renderer.domElement.addEventListener(
    'touchend',
    (event) => {
      mouseUp(event.changedTouches[0]);
    },
    false,
  );

  onContainerResize();
  animate();
  console.log('currentProduct', currentProduct);

  if (currentProduct != null) {
    loadObj();
  }
}

export function clearAllLogo() {
  let temp = [];
  scene.children.forEach((x) => {
    if (x.logo != null && x.logo.IsText !== true) {
      x.logo.Position = null;
      x.logo.Rotation = null;
      temp.push(x);
    }
  });
  temp.forEach((x) => {
    scene.remove(x);
  });
  window.decals = window.decals.filter((d) => d.logo && d.logo.IsText === true);
}

function updateLogoOnTab() {
  for (let i = 0; i < updateTheLogo.length; i++) {
    if (updateTheLogo[i](window.currentLogo) === true) return;
  }
}
export function deleteCurrentLogo() {
  deleteLogo(window.currentLogo);
}

export function deleteLogo(logo) {
  scene.remove(logo.decalMesh);
  var temp = [];

  window.decals.forEach(function (d) {
    if (d.logo.Id !== logo.Id) {
      temp.push(d);
    }
  });
  window.decals = temp;
}

export function clearLogo(logo) {
  scene.remove(logo.decalMesh);
  var temp = [];

  window.decals.forEach(function (d) {
    if (d.logo.Id !== logo.Id) {
      temp.push(d);
    } else {
      d.logo.Position = null;
      d.logo.Orientation = null;
    }
  });
  window.decals = temp;
}

export function updateLogoChange(logo) {
  window.currentLogo = logo;

  if (window.currentLogo.Orientation) {
    scene.remove(window.currentLogo.decalMesh);
    let orientationTemp = new THREE.Euler();
    orientationTemp.copy(window.currentLogo.Orientation);
    orientationTemp.z += (window.currentLogo.Rotate * Math.PI) / 180;

    const scale = window.currentLogo.Scale;
    const { multiplierX, multiplierY } = computeMultiplierBasedOnRatio(
      window.currentLogo.ratio ?? 1,
    );
    if (window.currentLogo.IsText) {
      size.set(scale, scale, scale);
    } else {
      size.set(
        scale * defaultSize * multiplierX,
        scale * defaultSize * multiplierY,
        scale * defaultSize,
      );
    }

    const material = window.currentLogo.decalMaterial;
    window.currentLogo.decalMesh = new THREE.Mesh(
      new THREE.DecalGeometry(
        intersection.mesh,
        window.currentLogo.Position,
        orientationTemp,
        size,
      ),
      material,
    );
    window.currentLogo.decalMesh.logo = window.currentLogo;
    if (window.currentLogo.IsPattern === false) {
      window.currentLogo.decalMesh.renderOrder = 1;
    }
    addObject(scene, window.currentLogo.decalMesh);

    const temp = [];
    window.decals.forEach(function (d) {
      if (d.logo.Id !== window.currentLogo.Id) {
        temp.push(d);
      } else {
        temp.push(window.currentLogo.decalMesh);
      }
    });
    window.decals = temp;
  }
}

export function updateLogoSelect(logo) {
  window.currentLogo = logo;
  if (window.currentLogo == null) return;

  // Check if logo is on model (exists in window.decals)
  const isLogoOnModel =
    window.decals &&
    window.decals.some(
      (d) => d.logo && d.logo.Id === window.currentLogo.Id && d.logo.IsText !== true,
    );

  // If logo is not on model and Position is null or invalid, ensure clean state
  // But don't reset if Position is already a valid Vector3 (e.g., during restore)
  if (!isLogoOnModel) {
    // Only reset Position if it's null or not a valid Vector3
    if (!window.currentLogo.Position || !(window.currentLogo.Position instanceof THREE.Vector3)) {
      window.currentLogo.Position = null;
    }
    // Reset Orientation if it's not a valid THREE.Euler instance
    if (
      !window.currentLogo.Orientation ||
      !(window.currentLogo.Orientation instanceof THREE.Euler) ||
      typeof window.currentLogo.Orientation.copy !== 'function'
    ) {
      window.currentLogo.Orientation = null;
    }
  }

  if (!window.currentLogo.decalMaterial) {
    textureLoader.crossOrigin = 'Anonymous';
    const decalDiffuse = textureLoader.load(
      window.currentLogo.Thumbnail + '?not-from-cache-please',
    );
    decalDiffuse.minFilter = THREE.LinearFilter;

    window.currentLogo.decalMaterial = new THREE.MeshPhongMaterial({
      specular: 0x444444,
      map: decalDiffuse,
      normalScale: new THREE.Vector2(1, 1),
      shininess: 50,
      transparent: true,
      opacity: 0.8,
      depthTest: true,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -4,
      wireframe: false,
    });
  }
}

export function cameraCenter() {
  const offset = 2;
  const boundingBox = new THREE.Box3();

  // get bounding box of object - this will be used to setup controls and camera
  boundingBox.setFromObject(object);

  //ERRORS HERE
  const center = boundingBox.getCenter();
  const size = boundingBox.getSize();
  // get the max side of the bounding box (fits to width OR height as needed )
  const maxDim = Math.max(size.x, size.y, size.z);
  const fov = 60 * (Math.PI / 180);
  let cameraZ = Math.abs(maxDim / (2 * Math.tan(fov / 2))); //Applied fifonik correction

  cameraZ *= offset; // zoom out a little so that objects don't fill the screen
  defaultSize = maxDim / 20;

  camera.position.set(center.x, center.y, center.z + cameraZ); //Multiply unit vector times cameraZ distance
  camera.lookAt(center); //Look at object

  if (controls) {
    controls.minDistance = maxDim / 2;
    controls.maxDistance = maxDim * 5;

    // set camera to rotate around center of loaded object
    camera.lookAt(center);
    controls.target = center;
    controls.saveState();
    camera.updateProjectionMatrix();
  } else {
    camera.lookAt(center);
  }
}

function fitCameraToObject(camera, object, offset, controls) {
  offset = offset || 1.25;
  const boundingBox = new THREE.Box3();

  // get bounding box of object - this will be used to setup controls and camera
  boundingBox.setFromObject(object);

  //ERRORS HERE
  const center = boundingBox.getCenter();
  const size = boundingBox.getSize();
  // get the max side of the bounding box (fits to width OR height as needed )
  const maxDim = Math.max(size.x, size.y, size.z);
  const fov = 60 * (Math.PI / 180);
  let cameraZ = Math.abs(maxDim / (2 * Math.tan(fov / 2))); //Applied fifonik correction

  cameraZ *= offset; // zoom out a little so that objects don't fill the screen

  //Default size = 2% of maxDim
  defaultSize = maxDim / 50;

  camera.position.set(center.x, center.y, center.z + cameraZ); //Multiply unit vector times cameraZ distance
  camera.lookAt(center); //Look at object

  if (controls) {
    controls.minDistance = maxDim / 2;
    controls.maxDistance = maxDim * 5;

    // set camera to rotate around center of loaded object
    camera.lookAt(center);
    controls.target = center;
    controls.saveState();
    camera.updateProjectionMatrix();
  } else {
    camera.lookAt(center);
  }
}

function loadTexture(onFinished) {
  if (textureURL == null) {
    onFinished();
    return;
  }
  if (textureURL.length > 0) {
    var text = textureURL.shift();

    textureLoader.load(text, (_texture) => {
      texture = _texture;
      if (mesh.length > 0) {
        for (let i = 0; i < mesh.length; i++) {
          mesh[i].material.map = texture;
          mesh[i].material.needsUpdate = true;
        }
      }
      loadTexture(onFinished);
    });
  } else {
    onFinished();
  }
}

export function loadProduct(product) {
  currentProduct = product;
  loadObj();
}

function loadObj() {
  try {
    if (camera == null || currentProduct == null) {
      window.isLoading = false;
      return;
    }

    function onProgress(xhr) {}

    function onLoad(obj) {
      if (object != null) {
        mesh = [];
        scene.remove(object);
      }

      object = obj;

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      object.traverse(function (child) {
        if (child.isMesh) {
          child.material.shininess = materialShininess;
          if (Array.isArray(child.material)) {
            child.material = child.material[0];
          }
          child.material.specular.setRGB(0.1, 0.1, 0.1);
          child.material.map = texture;
          child.material.side = THREE.DoubleSide;

          if (currentProduct.TextureNormal != null) {
            textureLoader.load(currentProduct.TextureNormal, (temptexture) => {
              if (isIOS && (temptexture.image.width > 1024 || temptexture.image.height > 1024)) {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = Math.min(temptexture.image.width, 1024);
                canvas.height = Math.min(temptexture.image.height, 1024);
                ctx.drawImage(temptexture.image, 0, 0, canvas.width, canvas.height);
                temptexture.image = canvas;
                temptexture.needsUpdate = true;
              }
              // This normal-map load is async and races with the restore flow
              // (LoadDecals/restoreTextures/restoreStyles run inside loadTexture).
              // If a pattern was already restored on this mesh, the pattern must
              // stay flat — re-applying the baked rib normal map here is what made
              // the pattern look striped. Keep it cleared and just stash the baked
              // normal so a later pattern-reset can restore the original look.
              const hasPattern = child.patternFile || child.updatedTexture;
              if (hasPattern) {
                child.normalMapOrigin = temptexture;
              } else {
                child.material.normalMap = temptexture;
              }
              child.material.needsUpdate = true;
              window.isLoading = false;
            });
          }

          child.updateMatrix();
          child.meshId = mesh.length;
          mesh.push(child);
        }
      });

      if (currentProduct.PartOpacities != null) {
        for (var i = 0; i < currentProduct.PartOpacities.length; i++) {
          var partOpacity = currentProduct.PartOpacities[i];
          if (mesh.length > partOpacity.ID) {
            mesh[partOpacity.ID].material.opacity = partOpacity.Opacity;
            if (partOpacity.Opacity < 1) {
              var material = mesh[partOpacity.ID].material;
              material.transparent = true;
              material.blending = THREE.CustomBlending;
              material.blendEquation = THREE.AddEquation; //default
              material.blendSrc = THREE.SrcAlphaFactor; //default
              material.blendDst = THREE.OneMinusSrcAlphaFactor; //default
            }
          }
        }
      }

      scene.add(object);

      if (window.defaultZoom == null) {
        fitCameraToObject(camera, object, 2, controls);
      } else {
        fitCameraToObject(camera, object, window.defaultZoom, controls);
      }

      // Apply default style immediately since styles are pre-loaded
      if (window.styleList && window.styleList.length > 0) {
        const defaultStyle = window.styleList[0];
        if (defaultStyle && defaultStyle.main_texture) {
          console.log('Applying default style on product load (styles pre-loaded):', defaultStyle);
          styleHandling?.updateUndoStyle(defaultStyle);
          styleHandling?.applyStyleToAllSections(defaultStyle);
        }
      }

      if (currentProduct.Texture != null) {
        textureURL = null;
        if (currentProduct.Styles != null) {
          let style = currentProduct.Styles[currentProduct.colorIdx];
          if (style?.Patterns != null) {
            textureURL = style.Patterns[currentProduct.patternIdx].PatternTexture.slice();
          }
        }

        if (textureURL == null) {
          textureURL = currentProduct.Texture.slice();
        }
      }
      loadTexture(() => {
        if (window.restoreDecals != null) {
          loadFonts(window.restoreDecals, function () {
            LoadDecals(window.restoreDecals);
            restoreTextures(window.restoreDecals);
            restoreStyles(window.restoreDecals);
          });
        }
      });
    }

    function onError() {}

    if (
      currentProduct !== null &&
      currentProduct.Mesh !== currentMeshUrl &&
      currentProduct.TextureNormal !== currentNormalUrl
    ) {
      currentMeshUrl = currentProduct.Mesh;
      currentNormalUrl = currentProduct.TextureNormal;
      var loader = new THREE.OBJLoader();

      loader.load(currentMeshUrl, onLoad, onProgress, onError);
    }
  } catch (error) {
    console.log('error', error);
    window.isLoading = false;
  } finally {
    window.isLoading = false;
  }
}

export function updateCurrentLogo(scale, rotate) {
  if (!window.currentLogo) return;
  if (window.currentLogo.IsPattern === true) return;
  if (!window.currentLogo.decalMesh) return;
  if (window.currentLogo.Scale === scale && window.currentLogo.Rotate === rotate) return;
  window.currentLogo.Scale = scale;
  window.currentLogo.Rotate = rotate;
  scene.remove(window.currentLogo.decalMesh);
  let orientationTemp = new THREE.Euler();
  // Check if Orientation exists and is a valid THREE.Euler instance
  if (
    !window.currentLogo.Orientation ||
    !(window.currentLogo.Orientation instanceof THREE.Euler) ||
    typeof window.currentLogo.Orientation.copy !== 'function'
  ) {
    window.currentLogo.Orientation = new THREE.Euler();
    window.currentLogo.Orientation.copy(mouseHelper.rotation);
  }
  orientationTemp.copy(window.currentLogo.Orientation);
  orientationTemp.z += (window.currentLogo.Rotate * Math.PI) / 180;
  const _scale = window.currentLogo.Scale;
  const { multiplierX, multiplierY } = computeMultiplierBasedOnRatio(window.currentLogo.ratio ?? 1);
  if (window.currentLogo.IsText) {
    size.set(_scale, _scale, _scale);
  } else {
    size.set(
      _scale * defaultSize * multiplierX,
      _scale * defaultSize * multiplierY,
      _scale * defaultSize,
    );
  }

  window.currentLogo.decalMesh = new THREE.Mesh(
    new THREE.DecalGeometry(intersection.mesh, window.currentLogo.Position, orientationTemp, size),
    window.currentLogo.decalMaterial,
  );
  window.currentLogo.decalMesh.logo = window.currentLogo;
  window.currentLogo.meshID = intersection.mesh?.meshId;

  addObject(scene, window.currentLogo.decalMesh);

  var temp = [];
  window.decals.forEach(function (d) {
    if (d.logo.Id !== window.currentLogo.Id) {
      temp.push(d);
    } else {
      temp.push(window.currentLogo.decalMesh);
    }
  });
  window.decals = temp;
}

function insertLogoOnModel() {
  console.log('insertLogoOnModel (window.decals)', window.decals);
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('decal') || toolbarActive.value === 'color') {
    return;
  }
  if (window.currentLogo) {
    if (typeof window.currentLogo.Scale === 'undefined') {
      window.currentLogo.Scale = 0.5;
      window.currentLogo.Rotate = 0;
    }
    if (
      window.currentLogo.Position === null ||
      typeof window.currentLogo.Position === 'undefined'
    ) {
      window.currentLogo.Position = new THREE.Vector3(
        intersection.point.x,
        intersection.point.y,
        intersection.point.z,
      );
      window.currentLogo.Orientation = new THREE.Euler();
      window.currentLogo.Orientation.copy(mouseHelper.rotation);

      let orientationTemp = new THREE.Euler();
      orientationTemp.copy(window.currentLogo.Orientation);
      orientationTemp.z += (window.currentLogo.Rotate * Math.PI) / 180;

      const _scale = window.currentLogo.Scale;
      const { multiplierX, multiplierY } = computeMultiplierBasedOnRatio(
        window.currentLogo.ratio ?? 1,
      );
      if (window.currentLogo.IsText) {
        size.set(_scale, _scale, _scale);
      } else {
        size.set(
          _scale * defaultSize * multiplierX,
          _scale * defaultSize * multiplierY,
          _scale * defaultSize,
        );
      }

      const material = window.currentLogo.decalMaterial;
      window.currentLogo.decalMesh = new THREE.Mesh(
        new THREE.DecalGeometry(
          intersection.mesh,
          window.currentLogo.Position,
          orientationTemp,
          size,
        ),
        material,
      );
      window.currentLogo.decalMesh.logo = window.currentLogo;
      window.currentLogo.meshID = intersection.mesh?.meshId;
      // {
      //   const bb = new THREE.Box3().setFromObject(intersection.mesh);
      //   console.log(
      //     '[PLACE] meshId',
      //     intersection.mesh?.meshId,
      //     '| bboxZ',
      //     bb.min.z.toFixed(2),
      //     '→',
      //     bb.max.z.toFixed(2),
      //     '| bboxCenter',
      //     bb
      //       .getCenter(new THREE.Vector3())
      //       .toArray()
      //       .map((v) => +v.toFixed(2)),
      //   );
      // }
      // handleScene(window.currentLogo.decalMesh);
      addObject(scene, window.currentLogo.decalMesh);
      window.decals.push(window.currentLogo.decalMesh);

      updateLogoOnTab();
    } else {
      scene.remove(window.currentLogo.decalMesh);

      //window.currentLogo.Position.copy(intersection.point);
      window.currentLogo.Position = new THREE.Vector3(
        intersection.point.x,
        intersection.point.y,
        intersection.point.z,
      );

      let orientationTemp = new THREE.Euler();
      orientationTemp.copy(mouseHelper.rotation);
      // Check if Orientation exists and is a valid THREE.Euler instance
      if (
        !window.currentLogo.Orientation ||
        !(window.currentLogo.Orientation instanceof THREE.Euler) ||
        typeof window.currentLogo.Orientation.copy !== 'function'
      ) {
        window.currentLogo.Orientation = new THREE.Euler();
      }
      window.currentLogo.Orientation.copy(mouseHelper.rotation);
      orientationTemp.z += (window.currentLogo.Rotate * Math.PI) / 180;
      const _scale = window.currentLogo.Scale;
      const { multiplierX, multiplierY } = computeMultiplierBasedOnRatio(
        window.currentLogo.ratio ?? 1,
      );
      size.set(
        _scale * defaultSize * multiplierX,
        _scale * defaultSize * multiplierY,
        _scale * defaultSize,
      );

      window.currentLogo.decalMesh = new THREE.Mesh(
        new THREE.DecalGeometry(
          intersection.mesh,
          window.currentLogo.Position,
          orientationTemp,
          size,
        ),
        window.currentLogo.decalMaterial,
      );
      window.currentLogo.decalMesh.logo = window.currentLogo;
      window.currentLogo.meshID = intersection.mesh?.meshId;

      addObject(scene, window.currentLogo.decalMesh);
    }
  }
}

export function updateDecals() {
  window.decals = [];
  scene.children.forEach((x) => {
    if (x.logo != null) {
      window.decals.push(x);
    }
  });
}

export function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  renderer.setSize(window.innerWidth, window.innerHeight);
}

function animate() {
  requestAnimationFrame(animate);
  if (controls.enableDamping) controls.update();
  renderer.render(scene, camera);
}

function light_update() {
  light.position.copy(camera.position);
}

export function allowDrop(event) {
  event.preventDefault();
}

export function drop(ev) {
  if (ev.changedTouches) {
    getMousePos(ev.changedTouches[0]);
  } else {
    getMousePos(ev);
  }
  dragged = false;
  controls.enableRotate = true;
  checkIntersection();
  updateCurrent();
}

export function assignUVs(geometry) {
  geometry.faceVertexUvs[0] = [];

  geometry.faces.forEach(function (face) {
    var uvs = [];
    var ids = ['a', 'b', 'c'];
    for (var i = 0; i < ids.length; i++) {
      var vertex = geometry.vertices[face[ids[i]]].clone();

      var n = vertex.normalize();
      var yaw = 0.5 - Math.atan(n.z, -n.x) / (2.0 * Math.PI);
      var pitch = 0.5 - Math.asin(n.y) / Math.PI;

      var u = yaw,
        v = pitch;
      uvs.Push(new THREE.Vector2(u, v));
    }
    geometry.faceVertexUvs[0].Push(uvs);
  });

  geometry.uvsNeedUpdate = true;
}

// HELP FUNCTIONS
export function computeMultiplierBasedOnRatio(ratio = 1) {
  let multiplierX = 1,
    multiplierY = 1;
  if (ratio > 1) {
    multiplierY = 1 / ratio;
  } else if (ratio < 1) {
    multiplierX = ratio;
  }

  return { multiplierX, multiplierY };
}

export function realignLogoToSurface(logo) {
  if (
    !logo ||
    !logo.Position ||
    !mouseHelper ||
    !intersection ||
    !Array.isArray(mesh) ||
    mesh.length === 0
  ) {
    return;
  }

  const meshIndex = logo.MeshId ?? logo.meshID;
  const targetMesh = meshIndex != null && mesh[meshIndex] ? mesh[meshIndex] : null;
  const candidateMeshes = targetMesh ? [targetMesh] : mesh.slice();
  if (candidateMeshes.length === 0) return;

  let savedNormal = null;
  if (
    logo.Orientation &&
    logo.Orientation instanceof THREE.Euler &&
    typeof logo.Orientation.copy === 'function'
  ) {
    savedNormal = new THREE.Vector3(0, 0, 1).applyEuler(logo.Orientation).normalize();
  }

  let rayOrigin;
  let rayDirection;
  if (savedNormal && savedNormal.lengthSq() > 0) {
    const offset = (defaultSize || 1) * 100;
    rayOrigin = logo.Position.clone().add(savedNormal.clone().multiplyScalar(offset));
    rayDirection = savedNormal.clone().negate().normalize();
  } else {
    if (!camera || !camera.position) return;
    rayOrigin = camera.position.clone();
    rayDirection = new THREE.Vector3().subVectors(logo.Position, rayOrigin);
    if (rayDirection.lengthSq() === 0) return;
    rayDirection.normalize();
  }

  const helperRaycaster = new THREE.Raycaster();
  helperRaycaster.set(rayOrigin, rayDirection);
  const intersects = helperRaycaster.intersectObjects(candidateMeshes, true);
  if (!intersects.length) return;

  let hit = intersects[0];
  let bestDist = hit.point.distanceToSquared(logo.Position);
  for (let i = 1; i < intersects.length; i++) {
    const d = intersects[i].point.distanceToSquared(logo.Position);
    if (d < bestDist) {
      bestDist = d;
      hit = intersects[i];
    }
  }

  intersection.mesh = hit.object;
  intersection.point.copy(hit.point);
  mouseHelper.position.copy(hit.point);

  const normal = hit.face.normal.clone();
  normal.transformDirection(hit.object.matrixWorld);
  normal.multiplyScalar(10);
  normal.add(hit.point);
  mouseHelper.lookAt(normal);

  window.currentLogo = logo;
  window.currentLogo.Position = hit.point.clone();

  const resolvedMeshId = hit.object.meshId ?? meshIndex ?? window.currentLogo.meshID;
  window.currentLogo.meshID = resolvedMeshId;
  window.currentLogo.MeshId = resolvedMeshId;

  if (
    !window.currentLogo.Orientation ||
    !(window.currentLogo.Orientation instanceof THREE.Euler) ||
    typeof window.currentLogo.Orientation.copy !== 'function'
  ) {
    window.currentLogo.Orientation = new THREE.Euler();
  }
  window.currentLogo.Orientation.copy(mouseHelper.rotation);

  updateLogoChange(window.currentLogo);
}
